import { Component } from '@angular/core';

import { DynamicFormService } from '@ntap/common';

import { ParentItemProviderService } from '@app/shared';

@Component({
  selector: 'app-predaja',
  templateUrl: './predaja.component.html',
  providers: [DynamicFormService, ParentItemProviderService]
})
export class PredajaComponent {}
